var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMsgUnread = function SvgIcMsgUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.108253 4.94531C0.0145032 4.75781 -0.0792468 4.57031 0.108253 4.38281L0.389503 4.00781C0.483253 3.82031 0.764503 3.82031 0.952003 3.91406L3.577 5.60156C3.67075 5.69531 3.952 5.69531 4.04575 5.60156L10.8895 0.0703125C11.077 -0.0234375 11.2645 -0.0234375 11.452 0.0703125L11.6395 0.257813C11.827 0.445313 11.7333 0.632812 11.6395 0.820312L4.23325 8.13281C4.04575 8.32031 3.67075 8.32031 3.3895 8.13281L0.108253 4.94531Z",
    fill: "#2C2C2C",
    fillOpacity: 0.25
  })));
};
export default SvgIcMsgUnread;